import React, {useState, useEffect} from "react";
import { useHistory } from "react-router-dom";

import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import {Auth} from "aws-amplify";

import AddSpaceRow from "../../components/AddSpaceRow"
import { getAllSites, getBuildingsForSite, getBuildingFloors, addSpace, getBuildingSpaces, addVariable } from "../../services/MetadataService";
import { getBrickSpaceTypes, getPNNLSpaceTypes } from "../../services/DimensionsServices";

const AddSpaceForm = (props) => {
    let [sites, setSites] = useState()
    let [buildings, setBuildings] = useState([])
    let [floors, setFloors] = useState([])
    let [ existingSpaces, setExistingSpaces] = useState([])
    let [selectedSite, setSelectedSite] = useState() //TODO: Default these when called from other pages
    let [selectedBuilding, setSelectedBuilding] = useState()
    let [selectedFloor, setSelectedFloor] = useState()

    let [currentUser, setCurrentUser] = useState()

    let [brickTypes, setBrickTypes] = useState([])
    let [pnnlTypes, setPnnlTypes] = useState([])

    let [rows, setRows] = useState(0)
    let [spaces, setSpaces] = useState({})

    let [successCount, setSuccessCount] = useState(0)

    let history = useHistory();

    useEffect(() => {
        if (!sites) {
            getAllSites(false).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSites(response)
                if (props.siteId) {
                    let site = response.find(s => s.site_id == parseInt(props.siteId))
                    setSelectedSite(site)
                }
            })
        }

        if (brickTypes.length == 0) {
            getBrickSpaceTypes().then(response => {
                setBrickTypes(response)
            });
        }

        if (pnnlTypes.length == 0) {
            getPNNLSpaceTypes().then(response => {
                setPnnlTypes(response)
            })
        }

        if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }
    },[])

    useEffect(() => {
        if (selectedSite) {
            setSpaces({})
            setBuildings([])
            setFloors([])
            getBuildingsForSite(selectedSite.site_id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setBuildings(response)

                if (props.siteId == selectedSite.site_id && props.buildingId) {
                    let building = response.find(s => s.id == parseInt(props.buildingId))
                    setSelectedBuilding(building)
                } else {
                    setSelectedBuilding(null)
                }
            })
        }

    },[selectedSite])

    useEffect(() => {
        if (selectedBuilding) {
            setSpaces({})
            getBuildingFloors(selectedBuilding.id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setFloors(response)
            })

            getBuildingSpaces(selectedBuilding.id).then(response => {
                setExistingSpaces(response)
            })
        }

    },[selectedBuilding])

    useEffect(() => {
        if (selectedFloor) {
            setRows(1)
        }

    },[selectedFloor])

    const spacesToAddCallback = (id, space) => {
        let currentSpaces = Object.assign({}, spaces)

        let existingSpace = existingSpaces && existingSpaces.find(s => s.name === space.name)
        if (existingSpace) space.error = "A space with this name already exists"

        let addingSpace = Object.keys(spaces).find(index => index != id && spaces[index].name === space.name)
        if (addingSpace) space.error = "You have already added this space"
        currentSpaces[id] = space;

        setSpaces(currentSpaces)
    }

    const submitAll = () => {
        let currentSpaces = Object.assign({}, spaces)

        Object.keys(spaces).forEach(i => {
            let s = spaces[i]
            if (!s.success) {
                if (s.name && s.brick_space_type) {
                    addSpace(s).then(response => {
                        currentSpaces[i].success = true
                        currentSpaces[i].error = null

                        if (s.occupancy) {
                            let v = {
                                name: "Average occupancy",
                                value: s.occupancy,
                                collection_method_loe: "Easy",
                                collection_method: "Submittals / As-Builts",
                                collected_by: currentUser,
                                collection_date: new Date().toISOString().split('T')[0]
                            }
                            addVariable(v, "space", response.id).then(response => {
                                currentSpaces[i].success = true;
                                currentSpaces[i].error = null;
                                setSuccessCount(successCount + 1);
                                setSpaces(currentSpaces)
                            }).catch(err => {
                                console.log(err)
                                currentSpaces[i].success = true;
                                currentSpaces[i].error = "Space was added, but adding occupancy failed.  Go to Space Configuration to enter value.";
                                setSpaces(currentSpaces)
                            })
                        } else {
                            setSuccessCount(successCount + 1)
                            setSpaces(currentSpaces)
                        }
                        
                    }).catch(err => {
                        currentSpaces[i].success = false
                        currentSpaces[i].error = "Failed to add space"
                        console.log(err)
                        setSpaces(currentSpaces)
                    })
                } else {
                    currentSpaces[i].success = false;
                    currentSpaces[i].error = "Name and Type fields are required.";
                    setSpaces(currentSpaces)
                }
            } 

        })

    }

    if (!sites) return null;

    if (successCount === rows && rows != 0) {
        if (rows > 0) {
            history.push("/locations/" + selectedSite.site_id)
        } else if (rows == 1) {
            //TODO: Redirect to the space except we don't know what it is currently
        }
        
    }

    let addRows = [];
    for (let i = 0; i < rows; i++) {
        let lastSpace =  (i > 0) ? spaces[i-1] : null;
        let defaultFloorToCeiling = selectedBuilding.floor_to_ceiling_height && selectedBuilding.floor_to_ceiling_height > 0 ?  selectedBuilding.floor_to_ceiling_height : selectedSite.floor_to_ceiling_height && selectedSite.floor_to_ceiling_height > 0 ? selectedSite.floor_to_ceiling_height : null

        let space = spaces[i] || {
            site_id:selectedSite.site_id,
            building_id:selectedBuilding.id,
            floor_id:selectedFloor.id,
            brick_space_type: lastSpace ? lastSpace.brick_space_type : null,
            pnnl_space_type: lastSpace ? lastSpace.pnnl_space_type : null,
            floor_to_ceiling_height: lastSpace ? lastSpace.floor_to_ceiling_height : defaultFloorToCeiling
        }

        let key = "site_" + selectedSite.site_id + "_space_" + i
        addRows.push(
            <AddSpaceRow key={key} row_num={i} callback={spacesToAddCallback} spaceTypes={brickTypes} pnnlTypes={pnnlTypes} space={space}  />
        )
    }

    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="site"
                        options={sites}
                        getOptionLabel={option => option.name}
                        defaultValue={sites.find(s => s.site_id == props.siteId)}
                        getOptionSelected={(option, value) => option.site_id === value.site_id}
                        renderInput={(params) => <TextField {...params} label="Site" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSite(newValue);
                        }}
                    />
                </div>


            {
                buildings && buildings.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="buildings"
                        options={buildings}
                        defaultValue={buildings.find(b => b.id == props.buildingId)}
                        getOptionSelected={(option, value) => option.id === value.id}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => <TextField {...params} label="Building" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedBuilding(newValue);
                        }}
                    />
                </div> : null
            }

            {
                floors && floors.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="floors"
                        options={floors}
                        getOptionLabel={option => option.name}
                        getOptionSelected={(option, value) => option.id === value.id}
                        renderInput={(params) => <TextField {...params} label="Floor" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedFloor(newValue);
                        }}
                    />
                </div> : null
            }

            {
                selectedSite && selectedBuilding && selectedFloor ?
                <div className="add-container">
                    <div className="instructions">Enter spaces for this area</div>
                    {
                        addRows
                    }
                   
                    <div className="form-buttons">
                        <div className="form-button-left" onClick={() => setRows(rows+1)}>Add Row</div>
                        <div className="form-button-right" onClick={submitAll}>Submit</div>
                    </div>
                </div> : null
            }

            </div>
        </div>

    )


}

export default AddSpaceForm;